import { render, staticRenderFns } from "./QAgencyBuildingSubmenu.vue?vue&type=template&id=0a6e4a6b&"
import script from "./QAgencyBuildingSubmenu.vue?vue&type=script&lang=js&"
export * from "./QAgencyBuildingSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports